module.exports = __webpack_public_path__ + "static/media/0325_IMG_LE_PLAFOND_CHROMATIC_CH2_1039.99f21340.png";